import { Box, Button, Text } from "grommet";
import { useCountdown } from "../../hooks/useCountdown";
import { Pause, Play, Stop } from "grommet-icons";
import styled from "styled-components";

export const CountdownTimer = () => {

    const { isActive, timeLeft, toggleTimer, stopTimer, addTime } = useCountdown();

    // --- Вспомогательные функции рендера (те же, что и раньше) ---
    const pad = (num) => String(num).padStart(2, '0');

    const renderTimeDisplay = () => {
        const ms = Math.floor((timeLeft % 1000) / 10);
        const totalSeconds = Math.floor(timeLeft / 1000);
        const seconds = totalSeconds % 60;
        const minutes = Math.floor((totalSeconds / 60) % 60);
        const hours = Math.floor((totalSeconds / 3600) % 24);
        const days = Math.floor(totalSeconds / (3600 * 24));

        if (days > 0) {
            return (
                <Text size="4xl">
                    {days}:{pad(hours)}:{pad(minutes)}:{pad(seconds)}
                </Text>
            );
        }
        if (hours > 0) {
            return (
                <Text size="4xl">
                    {pad(hours)}:{pad(minutes)}:{pad(seconds)}
                </Text>
            );
        }
        return (
            <Text size="4xl">
                {pad(minutes)}:{pad(seconds)}:{pad(ms)}
            </Text>
        );
    };

    return (
        <Box align="center" flex gap="xsmall">
            <Box align="center">
                {timeLeft === 0 && !isActive ? (
                    <Text size="4xl">00:00:00</Text>
                ) : (
                    renderTimeDisplay()
                )}
            </Box>
            <Box direction="row">
                <Button icon={isActive ? <Pause/> : <Play/>} onClick={toggleTimer}/>
                <Button icon={<Stop/>} onClick={stopTimer}/>
            </Box>
            <TimerControls addTime={addTime} />
        </Box>
    )
}

const TimerControls = ({ addTime }) => {

    return (
        <Box width={'100%'}>
            <Box direction="row">
                <TimeButton onClick={() => addTime(30, 's')} hoverIndicator={true} focusIndicator={false} flex round={{ size: 'small', corner: 'top-left' }} border={{ size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'top' }}>+30s</TimeButton>
                <TimeButton onClick={() => addTime(1, 'm')} hoverIndicator={true} focusIndicator={false} flex border={{ size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'top' }}>+1m</TimeButton>
                <TimeButton onClick={() => addTime(5, 'm')} hoverIndicator={true} focusIndicator={false} flex border={{ size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'top' }}>+5m</TimeButton>
                <TimeButton onClick={() => addTime(30, 'm')} hoverIndicator={true} focusIndicator={false} flex border={{ size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'top' }}>+30m</TimeButton>
                <TimeButton onClick={() => addTime(1, 'h')} hoverIndicator={true} focusIndicator={false} flex border={{ size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'top' }}>+1h</TimeButton>
                <TimeButton onClick={() => addTime(1, 'd')} hoverIndicator={true} focusIndicator={false} flex round={{ size: 'small', corner: 'top-right' }} border={[{ size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'top' }, { size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'right' }]}>+1d</TimeButton>
            </Box>
            <Box direction="row">
                <TimeButton onClick={() => addTime(-30, 's')} hoverIndicator={true} focusIndicator={false} flex round={{ size: 'small', corner: 'bottom-left' }} border={{ size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'bottom' }}>-30s</TimeButton>
                <TimeButton onClick={() => addTime(-1, 'm')} hoverIndicator={true} focusIndicator={false} flex border={{ size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'bottom' }}>-1m</TimeButton>
                <TimeButton onClick={() => addTime(-5, 'm')} hoverIndicator={true} focusIndicator={false} flex border={{ size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'bottom' }}>-5m</TimeButton>
                <TimeButton onClick={() => addTime(-30, 'm')} hoverIndicator={true} focusIndicator={false} flex border={{ size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'bottom' }}>-30m</TimeButton>
                <TimeButton onClick={() => addTime(-1, 'h')} hoverIndicator={true} focusIndicator={false} flex border={{ size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'bottom' }}>-1h</TimeButton>
                <TimeButton onClick={() => addTime(-1, 'd')} hoverIndicator={true} focusIndicator={false} flex round={{ size: 'small', corner: 'bottom-right' }} border={[{ size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'bottom' }, { size: '1px', color: 'rgba(75, 75, 75, 1)', side: 'right' }]}>-1d</TimeButton>
            </Box>
        </Box>
    )
}

const TimeButton = styled(Box)`
  padding: 3px 6px;
  border-left: 1px solid rgba(75, 75, 75, 1);
  font-size: 12px;
  align-items: center;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none;     /* IE 10 and IE 11 */
  user-select: none;         /* Standard syntax */
`;